import { createEvent } from '@packages/events/lib/createEvent';

export const dispatchEvent = (element: any, event: any, data: any = {}) => {
    if (element) {
        element.dispatchEvent(createEvent(event, data));
    }
};

export const dispatchWindowEvent = (event: any, data?: any) => {
    if (typeof window !== 'undefined') {
        dispatchEvent(window, event, data);
    }
};
